import APP_CONST from '../../constants';
import LoginPage from './login';
import { ROUTER_CONST } from '../../router';
import { ClientManager } from '../../services';


export default {
    name: 'login',
    url: '/login?{client}{app}{email}{password}{returnUrl}',
    component: LoginPage,
    layout: APP_CONST.LAYOUT_PARTIAL,
    visibility: ROUTER_CONST.STATE_VISIBILITY_PUBLIC,
    resolve: [{
        token: 'persistClient',
        deps: ['$transition$'],
        resolveFn: (trans) => {
            if (trans.params().client) {
                try {
                    ClientManager.client(trans.params().client);
                } catch (err) {
                    console.error(err.message);
                }
            }

            if (trans.params().app) {
                try {
                    ClientManager.app(trans.params().app);
                } catch (err) {
                    console.error(err.message);
                }
            }

            if (trans.params().returnUrl) {
                try {
                    ClientManager.returnUrl(decodeURIComponent(trans.params().returnUrl));
                } catch (err) {
                    console.error(err.message);
                }
            }

            return true;
        }
    }]
};
